import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  navigate() {
    window.location = this.element.selectedOptions[0].dataset.url;
  }
}
